<template>
  <main class="page-operative page-operative-data-analysis page-operative-data-analysis-investimenti page-operative-data-analysis-investimenti-edit">
    <div class="container">
      <PageTitle>Modifica investimento</PageTitle>

      <div v-if="loading">LOADING ...</div>
      <div v-else-if="errorLoadingData">Investimento da modificare non trovato</div>
      <FormInvestimento v-else-if="company && userCanEdit" :investimento.sync="investimento" edit @saved="saveInvestimento" />
      <div v-else-if="company">Utente non abilitato</div>
    </div>
  </main>
</template>

<script>

import operativePageMixin from '../../../../../mixins/operativePage';

export default {
  name: 'page-operative-company-data-analysis-investimenti-edit',
  mixins: [operativePageMixin],
  components: {
    PageTitle: () => import('../../../../components/Layout/LayoutOperative/PageTitle'),
    FormInvestimento: () => import('../../../../components/Operative/Form/FormInvestimento'),
  },
  data () {
    return {
      investimento: null,
      loading: true,
      errorLoadingData: false,
    };
  },
  methods: {
    saveInvestimento (investimento) {
      this.$api.updateInvestimento(this.company.id, investimento.id, investimento)
        .then(() => {
          this.$router.push({
            name: 'operative-company.data-analysis.investimenti',
            query: {
              forecast: this.$route.query?.forecast || null,
            },
          });
        })
        .catch(this.$log.error)
      ;
    },
  },
  mounted () {
    this.loading = true;
  },
  watch: {
    company: {
      immediate: true,
      handler: function () {
        if (!this.company) {
          return;
        }

        this.$api.getInvestimento(this.company.id, this.$route.params.investimentoId)
          .then(res => {
            this.investimento = res.data;
          })
          .catch(err => {
            this.errorLoadingData = true;
            this.$log.error(err);
          })
          .finally(() => {
            this.loading = false;
          })
        ;
      },
    },
  },
};

</script>
